import { useEffect, useRef } from "react";
import PDFObject from "pdfobject";
import { Box } from "@mui/system";
import { FilePreviewViewProps } from "src/components/views/documents/preview/FilePreviewView.tsx";

export const PdfView = ({ fileHandle }: FilePreviewViewProps) => {
	const containerRef = useRef<HTMLDivElement>();

	useEffect(() => {
		if (containerRef.current) {
			containerRef.current.innerHTML = "";
			PDFObject.embed(fileHandle.fileUrl, containerRef.current, {
				PDFJS_URL: `/static/pdfjs/web/viewer.html`
			});
		}
	}, [fileHandle]);

	return <Box ref={containerRef}
				sx={{
					flex: 1
				}} />;
};

